export default __webpack_public_path__ + "static/media/3c.b021f782.png";